var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDTtelecomColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 646.2 450.6",
    style: {
      enableBackground: "new 0 0 646.2 450.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E20474;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.6,259.6v-39.7h39.7v39.7H249.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.8,259.6v-39.7h39.7v39.7H129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224.3,283.6c0,12.6,1.8,20.8,5.5,24.5c3.1,3.2,8.4,5.2,15.9,5.9c2.2,0.2,6,0.3,11.3,0.3v11h-95.6v-11 c7.7,0,13.4-0.4,17-1.1c7.4-1.6,12.1-5.9,14-12.9c1-3.7,1.5-9.2,1.5-16.7V139.5c-16.2,0.5-28.9,5.8-38.1,16.1 c-8.7,9.8-14,24.9-15.9,45.2l-10.3-1.8l1.9-68.9h155.4l1.9,68.9l-10.3,1.8c-1.9-20.3-7.3-35.4-16-45.2 c-9.2-10.3-21.9-15.7-38.2-16.1L224.3,283.6L224.3,283.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.2,259.6v-39.7h39.7v39.7H368.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M486.8,259.6v-39.7h39.7v39.7H486.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDTtelecomColor);
export default __webpack_public_path__ + "static/media/DTtelecom _color.a72530f8a3cdb366a6a1fd6b681ecd4e.svg";
export { ForwardRef as ReactComponent };